// src/features/articles/components/RecommendedArticleList.jsx
import React from "react";
import { Link } from "react-router-dom";
import { BsEye, BsClock } from "react-icons/bs";

function formatThaiShortDate(ts) {
  if (!ts) return "";
  let date = ts;

  // รองรับ Timestamp ของ Firestore
  if (typeof ts.toDate === "function") date = ts.toDate();

  if (!(date instanceof Date)) return "";

  return date.toLocaleDateString("th-TH", {
    day: "numeric",
    month: "short",
  });
}

export default function RecommendedArticleList({ articles = [] }) {
  if (!articles.length) return null;

  return (
    <div className="article-recommended">
      <h2 className="article-recommended-title">
        บทความที่คุณอาจสนใจ
      </h2>

      <div className="article-recommended-list">
        {articles.map((item) => (
          <Link
            key={item.id}
            to={`/articles/${item.slug}`}
            className="recommended-item"
          >
            {/* ด้านซ้าย: ข้อความ */}
            <div className="recommended-main">
              {/* บรรทัดบนสุด – category / subCategory */}
              <div className="recommended-meta-top">
                {item.category?.name && (
                  <span className="recommended-category">
                    {item.category.name}
                  </span>
                )}
                {item.level && (
                    <span className="recommended-level">
                      {item.level === "general"
                        ? "General"
                        : item.level === "beginner"
                        ? "Beginner"
                        : item.level === "intermediate"
                        ? "Intermediate"
                        : item.level === "advanced"
                        ? "Advanced"
                        : item.level}
                    </span>
                  )}
              </div>

              {/* title */}
              <h3 className="recommended-title">
                {item.title}
              </h3>

              {item.subtitle && item.subtitle.trim() !== "" && (
                  <p className="recommended-subtitle">
                    {item.subtitle}
                  </p>
              )}

              {/* excerpt ถ้ามี (เช่น field summary หรือ contentPreview) */}
             {/*  {item.summary && (
                <p className="recommended-excerpt">
                  {item.summary}
                </p>
              )} */}

              {/* บรรทัดล่าง – วันที่ / เวลาอ่าน / จำนวนวิว */}
              <div className="recommended-meta-bottom">
                {item.createdAt && (
                  <span>{formatThaiShortDate(item.createdAt)}</span>
                )}

                {typeof item.readTime === "number" && (
                  <>
                    <span>·</span>
                    <span>
                      {item.readTime} min read
                    </span>
                  </>
                )}

                {typeof item.views === "number" && (
                  <>
                    <span>·</span>
                    <span>
                      {item.views.toLocaleString()} views
                    </span>
                  </>
                )}
              </div>
            </div>

            {/* ด้านขวา: รูปปกเล็ก */}
            {item.cover && (
              <div className="recommended-thumb-wrapper">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="recommended-thumb"
                />
              </div>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}